import { AdaaHelper } from "../../../../../../../core/utils";
import { SharedFields, textField } from "../../configs";
import {
  AccordionSectionConfigType,
  ListSectionConfigType,
  ScreenSectionConfigType,
  ScreenType,
} from "../../wf-difference.types";

const titleField: ScreenSectionConfigType[] = (() => {
  const fields = textField("title", { use: "both" }) as ScreenSectionConfigType[];

  return fields.map((field) => ({
    ...field,
    label: `common.form.label.${field.field}`,
  }));
})();

const countryField: ScreenSectionConfigType = {
  field: "countryId",
  label: "international_projects.countries.single",
  view: "normal",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "countryName"),
};

const hostedField: ScreenSectionConfigType = {
  field: "hostedCountryId",
  label: "international_projects.visits.hosted_by",
  view: "normal",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "hostedCountryName"),
};

const visitTypeField: ScreenSectionConfigType = {
  field: "visitType",
  label: "international_projects.visits.visit_type",
  view: "normal",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "visitType"),
};

const achievementsField: ListSectionConfigType = {
  field: "achievements",
  label: "international_projects.visits.achievements",
  view: "list",
  idKey: "id",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "text"),
};

const responsibilityFields = () => {
  const fields = textField("responsibility", { use: "both" }) as ScreenSectionConfigType[];

  return fields.map((field) => ({
    ...field,
    label:
      field.field === "responsibilityAE"
        ? "international_projects.visits.responsibilityAE"
        : "international_projects.visits.responsibilityEN",
  }));
};

const delegationMembersSectionConfig: ScreenSectionConfigType[] = [...SharedFields.name, ...responsibilityFields()];

const delegationMembers: AccordionSectionConfigType = {
  view: "accordion",
  field: "delegationMembers",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "name"),
  idKey: "id",
  config: delegationMembersSectionConfig,
  label: "international_projects.visits.delegation_members",
};

export const visitsScreenConfig = {
  type: "simple" as ScreenType,
  sections: [
    ...titleField,
    SharedFields.startDate,
    SharedFields.endDate,
    countryField,
    hostedField,
    visitTypeField,
    achievementsField,
    delegationMembers,
    SharedFields.attachmentsField,
  ],
};
